import $ from 'jquery'

import Block from '../block'

export default class ShoppingcartShipping extends Block {
	static title = 'shoppingcart-shipping'

	constructor($el) {
		super($el)

		this.inputs = this.$el.find('input[name="shipping_id"]')
		this.inputs.each((index, el) => {
			$(el).on('change', () => {
				$(document).trigger('checkout:add-shipping-info', {
					shipping_tier: $(el).data('shippingTitle'),
				})
			})
		})
	}
}
